<template>
  <learning-center-feedback-form form-type="translation_error" />
</template>

<script>
import LearningCenterFeedbackForm from './learningCenterFeedbackForm.vue';

export default {
  name: 'LearningCenterTranslationErrorTab',
  components: {
    LearningCenterFeedbackForm,
  },
};
</script>

